<p-panel header="{{ 'fs.res.patent.patentFamily' | hisUi }}">

	<!-- info message to assign patents -->
	<div class="infoMessage" *ngIf="!patentFamily?.length" [innerHTML]="'fs.res.patent.infoAssignmentPatent' | hisUi"></div>

	<div *ngIf="patentFamily && patentFamily.length > 0">
		<h4>{{ 'fs.res.patent.assignedPatents' | hisUi }}</h4>
		<div>
			<p-table [value]="patentFamily" [paginator]="false">
				<ng-template pTemplate="header">
						<tr>
						<th>{{ 'fs.res.patent.Patent.title' | hisUi }}</th>
					    <th>{{ 'fs.res.patent.Patent.priorityPatent' | hisUi }}</th>
					    <th>{{ 'fs.res.patent.Patent.patentNumber' | hisUi }}</th>
					</tr>
				</ng-template>
			 	<ng-template pTemplate="body" let-patent>
					<tr>
						<td>{{ patent.title }}</td>
	    				<td>{{ patent.priorityPatent ? ('de.his.javang.nein.lowercase'|hisUi) : ('de.his.javang.ja.lowercase'|hisUi ) }}</td>
						<td>{{ patent.patentNumber }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

</p-panel>
